// @flow
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import I18n from 'i18n-react'
import csLanguage from '../Translations/cs.json'
import Button from 'reactstrap/lib/Button'
import Modal from 'reactstrap/lib/Modal'
import ModalHeader from 'reactstrap/lib/ModalHeader'
import ModalBody from 'reactstrap/lib/ModalBody'
import ModalFooter from 'reactstrap/lib/ModalFooter'
import Datetime from 'react-datetime'
import localforage from 'localforage'
import { cookie } from 'devx-js-utilities'

// moment
import moment from '../Moment'

// components
import Loader from '../Components/Loader'
import SelectInput from '../Components/_ui/SelectInput'
import TextInput from '../Components/_ui/TextInput'
import GoogleTagManager from '../Components/GoogleTagManager'
import ConfirmModal from '../Components/ConfirmModal'

// redux
import GeneralActions from '../Redux/GeneralRedux'
import UserDataActions from '../Redux/UserDataRedux'
import SettingsActions, { WEB_TYPES, WEB_TYPES_KEYS } from '../Redux/SettingsRedux'
import GTMActions from '../Redux/GTMRedux'

class RootContainer extends React.Component {
  static propTypes = {
    activeSettings: PropTypes.object.isRequired,
    callTopic: PropTypes.string.isRequired,
    callbackDate: PropTypes.string.isRequired,
    callbackTime: PropTypes.object.isRequired,
    callbackTimes: PropTypes.array.isRequired,
    callbackTimesFrom: PropTypes.array.isRequired,
    callbackTimesTo: PropTypes.array.isRequired,
    confirmModalEnabled: PropTypes.bool,
    contractId: PropTypes.string.isRequired,
    error: PropTypes.object.isRequired,
    fetching: PropTypes.bool.isRequired,
    firstName: PropTypes.string.isRequired,
    fromConnector: PropTypes.bool,
    getSettingsRequest: PropTypes.func.isRequired,
    lastName: PropTypes.string.isRequired,
    onChangeValidationError: PropTypes.func.isRequired,
    onChangeWebType: PropTypes.func.isRequired,
    onCreate: PropTypes.func,
    onFinish: PropTypes.func,
    onGetOperatingHoursRequest: PropTypes.func.isRequired,
    onSendCallbackRequest: PropTypes.func.isRequired,
    operatingHours: PropTypes.object.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    pushShowModal: PropTypes.bool,
    quoteId: PropTypes.string.isRequired,
    renderOnTheTop: PropTypes.func,
    requestId: PropTypes.string.isRequired,
    showInMobileVersion: PropTypes.bool,
    userDataContactPhone: PropTypes.func.isRequired,
    userDataDate: PropTypes.func.isRequired,
    userDataSetData: PropTypes.func.isRequired,
    userDataSetValue: PropTypes.func,
    userDataTime: PropTypes.func.isRequired,
    validationErrors: PropTypes.object,
    webType: PropTypes.number.isRequired,
  }

  static defaultProps = {
    onFinish: () => null,
    onCreate: () => null,
    showInMobileVersion: false,
  }

  state = {
    modal: false,
    shouldOpen: true,
    default: moment(),
    maxDate: moment().add(6, 'month'),
    callTime: '',
  }

  constructor(props) {
    super(props)
    I18n.setTexts({
      ...I18n.texts,
      cl: csLanguage,
    })

    this._localForageSuriData = localforage.createInstance({
      name: 'suriData',
    })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { mountNode } = nextProps
    const { hash } = location
    if (
      mountNode &&
      mountNode.dataset &&
      mountNode.dataset.main === '1' &&
      hash &&
      hash === '#kontaktovat' &&
      prevState &&
      !prevState.modal &&
      prevState.shouldOpen
    ) {
      return {
        modal: true,
        shouldOpen: false,
      }
    }
    return null
  }

  componentDidMount() {
    this.props.onCreate(this.handleChangeData, this.handleFormValidation, this.handleToggleModal)
    this.props.userDataGenTimes(moment())

    let domain = location.host
    if (domain.indexOf('sro') >= 0) {
      this.props.onChangeWebType(WEB_TYPES.SRO)
    } else if (domain.indexOf('sur') >= 0) {
      this.props.onChangeWebType(WEB_TYPES.SUR)
    } else if (domain.indexOf('pov') >= 0) {
      this.props.onChangeWebType(WEB_TYPES.POV)
    } else if (domain.indexOf('renomia') >= 0) {
      this.props.onChangeWebType(WEB_TYPES.REN)
    } else {
      this.props.onChangeWebType(WEB_TYPES.SUR)
    }

    this.props.getSettingsRequest()
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps.pushShowModal !== this.props.pushShowModal || prevState.modal !== this.state.modal) &&
      this._localForageSuriData
    ) {
      this._localForageSuriData.getItem('phoneNumber', (err, value) => {
        if (!err && value) {
          this.handleOnChangeContactPhoneNumber(value)
        }
      })
    }
  }

  handleChangeData = (data) => {
    this.props.userDataSetData(data)
  }

  handleOnChangeCallbackDate = (callbackDate) => {
    this.props.userDataDate(callbackDate.format('YYYY-MM-DD'))
    this.props.userDataGenTimes(callbackDate)
  }

  handleOnChangeCallbackTime = (callbackTime) => {
    this.props.userDataTime(callbackTime)
  }

  handleOnChangeContactPhoneNumber = (phoneNumber) => {
    const regex = /^\+?([0-9]{0,12})$/
    if (regex.test(phoneNumber)) {
      this.props.userDataContactPhone(phoneNumber)
    }
  }

  handleSendOpenGtmEvent = () => {
    this.props.addGtmEvent('Show', this.props.type === 'leaving' ? 'Leaving' : 'Popup')
  }

  handleToggleModal = (pushShow) => {
    const willBeOpened = typeof pushShow === 'boolean' ? pushShow : !this.props.modalOpened
    if (!this.props.fromConnector && willBeOpened === true) {
      this.props.userDataGenTimes(moment(this.props.callbackDate, 'YYYY-MM-DD'))
    }
    if (!this.props.fromConnector && this.props.sendLocalForageData) {
      this._localForageSuriData.getItem('callBackData').then((callBackData) => {
        if (callBackData && callBackData.length > 0) {
          try {
            this.handleChangeData(JSON.parse(callBackData))
          } catch (e) {
            this._localForageSuriData.removeItem('callBackData')
          }
        }
      })
    }

    if (willBeOpened) {
      this.handleSendOpenGtmEvent()
    }
    this.props.toggleModalOpened(willBeOpened)
    this.props.onFinish(false)
  }

  handleToggleConfirmModal = () => {
    this.props.toggleConfirmModal(false)
  }

  handleValidDate = (selectedDatetime) =>
    selectedDatetime.isBefore(this.state.maxDate) &&
    selectedDatetime.isSameOrAfter(this.state.default.startOf('day')) &&
    !this.props.closed.includes(selectedDatetime.format('YYYY-MM-DD'))

  handleOnChangeValidationError = (name, error) => {
    this.props.onChangeValidationError(name, error)
  }

  handleOnChangeSetStateDate = (date) => {
    this.handleOnChangeCallbackDate(date)
  }

  handleFormValidation = (showError = true, validate = true, attr = {}) => {
    if (!validate || this.phoneNumber.validate(showError)) {
      const {
        callbackDate,
        callbackTimes,
        callbackTime,
        callbackTimesFrom,
        callbackTimesTo,
        firstName,
        lastName,
        phoneNumber,
        productName,
        quoteId,
        requestId,
        webType,
        callTopic,
        contractId,
      } = this.props
      const labels = {
        phoneLabel: I18n.translate('cl.general.phone'),
        dateLabel: I18n.translate('cl.general.datePicker'),
        timeLabel: I18n.translate('cl.general.time'),
      }
      const selectedIndex = callbackTimes.findIndex((clTime) => clTime.value === callbackTime.value)
      let callFrom = callbackTimesFrom[selectedIndex]
      let callTo = callbackTimesTo[selectedIndex]
      let googleCookie = cookie.readCookie('_ga')
      let googleClientId =
        typeof googleCookie === 'string' && googleCookie.split('.').length > 2 && googleCookie.split('.').slice(2).join('.') || ''
      const affiliate = cookie.readCookie('affiliate') || ''
      const utmCampaign = cookie.readCookie('utm_campaign') || ''
      const utmMedium = cookie.readCookie('utm_medium') || ''
      const utmSource = cookie.readCookie('utm_source') || ''

      const data = {
        affiliate,
        callDate: callbackDate,
        callFrom,
        callTo,
        created: moment().format('YYYY-MM-DDTHH:mm'),
        firstName,
        lastName,
        phoneNumber,
        productName,
        quoteId,
        requestId,
        website: WEB_TYPES_KEYS[webType],
        callTopic,
        contractId,
        trackingParams: {
          googleClientId,
          ['utm-campaign']: utmCampaign,
          ['utm-medium']: utmMedium,
          ['utm-source']: utmSource,
        },
        ...attr,
      }
      this.props.onSendCallbackRequest(data, labels, this.props.type)
      this.props.onFinish(true, data)
      this.handleToggleModal(false)
    }
  }
  handleFormContent(selectedDate) {
    return (
      <>
        <ModalBody>
          <div id="callback" title="Zavoláme vám zpět">
            {this.props.renderOnTheTop &&
              typeof this.props.renderOnTheTop === 'function' &&
              this.props.renderOnTheTop()}
            <form>
              <div>
                <div className="col-xs-12 main-form">
                  <TextInput
                    id="phoneNumber"
                    inputType="tel"
                    isPhone
                    isRequired
                    label={I18n.translate('cl.general.phone')}
                    maxlength={9}
                    name="phoneNumber"
                    onChange={this.handleOnChangeContactPhoneNumber}
                    onErrorChange={this.handleOnChangeValidationError}
                    ref={(ref) => {
                      this.phoneNumber = ref
                    }}
                    type="tel"
                    validationErrors={this.props.validationErrors}
                    value={this.props.phoneNumber}
                  />
                  {!this.props.showInMobileVersion && (
                    <div className="d-none d-sm-block">
                      <div className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-center">
                        <div className="col-10 col-sm-3 order-0 order-sm-0 pt-sm-2 mt-sm-1 text-sm-right">
                          <label htmlFor="callbackDate">{I18n.translate('cl.general.datePicker')}</label>
                        </div>
                        <div className="col-12 col-sm-8 order-3 order-sm-0 offset-sm-1 mt-2 pr-sm-0">
                          <div className="react-datepicker">
                            <Datetime
                              closeOnSelect
                              closeOnTab
                              dateFormat="DD.MM.YYYY"
                              id="callbackDate"
                              input
                              inputProps={{
                                className: 'bg-white form-control',
                                readOnly: true,
                              }}
                              isValidDate={this.handleValidDate}
                              locale="cs-CZ"
                              // onBlur={this.handleOnBlurCheckDate}
                              onChange={this.handleOnChangeSetStateDate}
                              timeFormat={false}
                              value={selectedDate}
                            />
                          </div>
                        </div>
                      </div>
                      <SelectInput
                        className="form-group row"
                        id="callbackTime"
                        label={I18n.translate('cl.general.time')}
                        name="callbackTime"
                        onChange={this.handleOnChangeCallbackTime}
                        options={this.props.callbackTimes}
                        searchable={false}
                        value={this.props.callbackTime.value}
                        wrapperClassName="width-50"
                      />
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
          <Loader active={this.props.fetching} />
        </ModalBody>
        <ModalFooter className="border-0">
          <div className="text-center">
            <Button onClick={this.handleFormValidation}>{I18n.translate('cl.general.send')}</Button>
            {this.props.activeSettings.domain && (
              <div className="agreementText text-left pt-3 mt-2">
                {I18n.translate('cl.general.agreementBeforeLink')}
                <a
                  href={`${this.props.activeSettings.domain}informace-o-zpracovani-osobnich-udaju/`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {I18n.translate('cl.general.agreementLinkText')}
                </a>
                &nbsp;
                {I18n.translate('cl.general.agreementAfterLink')}
              </div>
            )}
          </div>
        </ModalFooter>
      </>
    )
  }
  render() {
    const { callbackDate, mountNode, pushShowModal, modalOpened, showOnlyModalContent } = this.props
    let buttonText = ''
    let buttonTextClass = ''
    let buttonClass = ''
    let appId = 'callback-content'
    let buttonIconClass = ''
    if (mountNode && mountNode.dataset) {
      buttonText = mountNode.dataset.buttonText || ''
      buttonClass = mountNode.dataset.buttonClass || ''
      buttonTextClass = mountNode.dataset.buttonTextClass || ''
      buttonIconClass = mountNode.dataset.buttonIconClass || ''
      appId = mountNode.dataset.id || 'callback-content'
    }
    let selectedDate = moment()
    if (callbackDate) {
      selectedDate = moment(callbackDate, 'YYYY-MM-DD')
    }

    return (
      <div id={appId}>
        {typeof pushShowModal !== 'boolean' && !showOnlyModalContent && (
          <Button className={`text-nowrap ${buttonClass}`} onClick={this.handleToggleModal}>
            <span className={buttonTextClass}>
              {buttonText ? buttonText : I18n.translate('cl.general.modalButtonText')}
            </span>
            {buttonIconClass && <span className={buttonIconClass} />}
          </Button>
        )}
        {!showOnlyModalContent && (
          <Modal isOpen={pushShowModal || modalOpened} toggle={this.handleToggleModal}>
            <ModalHeader>
              {I18n.translate('cl.general.modalTitle')}
              <button className="close" onClick={this.handleToggleModal} type="button">
                <i className="pfp pfp-close" />
              </button>
            </ModalHeader>
            {this.handleFormContent(selectedDate)}
          </Modal>
        )}
        {showOnlyModalContent && this.handleFormContent(selectedDate)}
        <ConfirmModal
          callDate={this.props.callbackDate}
          callTime={this.props.callbackTime.label}
          isOpen={
            (!this.props.fromConnector && this.props.confirmOpenModal) ||
            (this.props.confirmModalEnabled && this.props.confirmOpenModal)
          }
          toggleModal={this.handleToggleConfirmModal}
        />
        <GoogleTagManager id="GTM-MFQZH73" />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  activeSettings: state.settings.activeSettings,
  affiliate: state.userData.data.affiliate,
  callbackDate: state.userData.data.callbackDate,
  callbackTime: state.userData.data.callbackTime,
  callbackTimes: state.userData.data.callbackTimes,
  callbackTimesFrom: state.userData.data.callbackTimesFrom,
  callbackTimesTo: state.userData.data.callbackTimesTo,
  callTopic: state.userData.data.callTopic,
  closed: state.userData.closed,
  confirmOpenModal: state.general.confirmOpenModal,
  contractId: state.userData.data.contractId,
  error: state.general.error,
  fetching: state.general.fetching,
  firstName: state.userData.data.firstName,
  lastName: state.userData.data.lastName,
  modalOpened: state.userData.data.modalOpened,
  operatingHours: state.general.operatingHours,
  phoneNumber: state.userData.data.contact.phoneNumber,
  productName: state.userData.data.productName,
  quoteId: state.userData.data.quoteId,
  requestId: state.userData.data.requestId,
  validationErrors: state.general.validationErrors,
  webType: state.settings.webType,
})

const mapDispatchToProps = {
  ...GeneralActions,
  ...UserDataActions,
  ...SettingsActions,
  addGtmEvent: GTMActions.addGtmEvent,
}

export default connect(mapStateToProps, mapDispatchToProps)(RootContainer)
